import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageModule } from '../language/language.module';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslationModule } from '../translation/translation.module';
import { FooterModule } from '../footer/footer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileexplorerComponent } from './fileexplorer/fileexplorer.component';
import { FilemanagerComponent } from './filemanagerpopup/filemanagerpopup.component';
import { DeletefilepopupComponent } from './filemanagerpopup/deletefilepopup/deletefilepopup.component';
import { ClipboardModule } from '@angular/cdk/clipboard';


@NgModule({
    declarations: [FileexplorerComponent,FilemanagerComponent,DeletefilepopupComponent],
    exports: [FileexplorerComponent,FilemanagerComponent,DeletefilepopupComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],

    imports: [
        CommonModule,
        LanguageModule,
        RouterModule,
        TranslationModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        FooterModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatDialogModule,
        ClipboardModule
    ]
})
export class FilemanagerModule { }
